import { formatINR } from "@/config";

export const ComboTotals = ({ quote, title }) => (
  <div data-testid="combo-preview-pricing" className="space-y-3 [overflow-wrap:anywhere]">
    <dl className="space-y-2 text-sm">
      <div className="flex justify-between gap-4 text-slate-300">
        <dt>Products separately</dt><dd data-testid="combo-preview-subtotal">{formatINR(quote.subtotal)}</dd>
      </div>
      <div className="flex justify-between gap-4 text-[#F5C45A]">
        <dt>{quote.discount_label && quote.discount_label !== title ? "Best full-set discount" : "Combo discount"}</dt>
        <dd data-testid="combo-preview-discount">−{formatINR(quote.discount)}</dd>
      </div>
      <div className="flex items-baseline justify-between gap-4 border-t border-white/10 pt-3 font-display font-bold text-white">
        <dt>Full combo total</dt><dd data-testid="combo-preview-total" className="text-2xl text-[#FFE9B0]">{formatINR(quote.total)}</dd>
      </div>
    </dl>
    <p data-testid="combo-preview-terms" className="text-xs leading-relaxed text-slate-400">Full set only. One combo or total-price offer per order; the biggest saving applies.</p>
  </div>
);